/* ============================================================================
  Curated Pin — AVONE 6
  - first=HANDLE oder first={{product.url}}
  - variant= optional
  - limit= optional
============================================================================ */
(() => {
  const qp = new URLSearchParams(location.search);
  const rawFirst = (qp.get("first") || "").trim();
  if (!rawFirst) return;

  const prehide = () => document.documentElement.classList.add("curated-prehide");
  const reveal = () => {
    document.documentElement.classList.remove("curated-prehide");
    document.documentElement.classList.add("curated-ready");
  };

  let firstHandle = "";
  let variantID = (qp.get("variant") || "").trim();

  if (rawFirst.startsWith("http")) {
    try {
      const u = new URL(rawFirst, location.origin);
      if (u.origin !== location.origin) { reveal(); return; }

      const segs = u.pathname.split("/").filter(Boolean);
      if (segs[0] === "products" && segs[1]) firstHandle = segs[1];

      if (!variantID) variantID = (u.searchParams.get("variant") || "").trim();
    } catch {
      reveal();
      return;
    }
  } else {
    const segs = rawFirst.split("/").filter(Boolean);
    firstHandle = segs.pop() || "";
  }

  if (!firstHandle) { reveal(); return; }

  const limit = Math.max(0, parseInt(qp.get("limit") || "0", 10) || 0);

  const GRID_SEL = "#collection-products.grid-products";
  const CARD_SEL = ".gitem";
  const LOCK_ATTR = "data-curated-pin";
  const KEY = `${firstHandle}|${variantID}|${limit}`;

  const getGrid = () => document.querySelector(GRID_SEL);

  const getHandleFromHref = (href = "") => {
    const m = href.match(/\/products\/([^?/#]+)/);
    return m ? m[1] : "";
  };

  const isPinnedCard = (card) => {
    const a = card?.querySelector?.('a[href*="/products/"]');
    if (!a) return false;
    return getHandleFromHref(a.getAttribute("href") || "") === firstHandle;
  };

  const findPinnedCard = (grid) => {
    const cards = Array.from(grid.querySelectorAll(CARD_SEL));
    return cards.find(isPinnedCard) || null;
  };

  const dedupePinned = (grid) => {
    const cards = Array.from(grid.querySelectorAll(CARD_SEL)).filter(isPinnedCard);
    for (let i = 1; i < cards.length; i++) cards[i].remove();
  };

  const applyVariant = (card) => {
    if (!variantID || !/^\d+$/.test(variantID)) return;

    card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      try {
        const u = new URL(a.getAttribute("href"), location.origin);
        u.searchParams.set("variant", variantID);
        a.setAttribute("href", u.pathname + "?" + u.searchParams.toString());
      } catch {}
    });
  };

  const trimToLimit = (grid) => {
    if (!limit) return;

    const items = Array.from(grid.querySelectorAll(":scope > .gitem"));
    for (let i = items.length - 1; i >= limit; i--) {
      items[i].remove();
    }
  };

  const fetchPinnedHTML = async () => {
    const url =
      `/products/${encodeURIComponent(firstHandle)}?view=curated-card` +
      (variantID && /^\d+$/.test(variantID) ? `&variant=${variantID}` : "");

    const r = await fetch(url, {
      credentials: "same-origin",
      cache: "force-cache"
    });

    if (!r.ok) return "";
    return await r.text();
  };

  const htmlToCard = (html) => {
    if (!html || !html.trim()) return null;

    const t = document.createElement("template");
    t.innerHTML = html.trim();

    t.content.querySelectorAll("script").forEach((s) => s.remove());

    return t.content.querySelector(".gitem");
  };

  let running = false;

  const run = async () => {
    const grid = getGrid();

    if (!grid) {
      reveal();
      return;
    }

    prehide();

    if (running) {
      reveal();
      return;
    }

    if (grid.getAttribute(LOCK_ATTR) === KEY) {
      reveal();
      return;
    }

    running = true;

    try {
      dedupePinned(grid);

      let pinned = findPinnedCard(grid);

      if (pinned) {
        if (grid.firstElementChild !== pinned) {
          grid.insertBefore(pinned, grid.firstElementChild);
        }

        applyVariant(pinned);
        dedupePinned(grid);
        trimToLimit(grid);

        grid.setAttribute(LOCK_ATTR, KEY);
        reveal();
        return;
      }

      const html = await fetchPinnedHTML();
      const card = htmlToCard(html);

      if (card) {
        grid.insertBefore(card, grid.firstElementChild);

        applyVariant(card);
        dedupePinned(grid);
        trimToLimit(grid);
      }

      grid.setAttribute(LOCK_ATTR, KEY);
      reveal();
    } catch {
      reveal();
    } finally {
      running = false;
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  window.addEventListener("pageshow", () => {
    if (new URLSearchParams(location.search).get("first")) run();
  });

  const obs = new MutationObserver(() => {
    if (!new URLSearchParams(location.search).get("first")) return;

    clearTimeout(obs._t);
    obs._t = setTimeout(run, 150);
  });

  const startObs = () => {
    const grid = getGrid();
    if (grid) obs.observe(grid, { childList: true, subtree: false });
  };

  startObs();
})();